export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-100">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-gemini-line text-lg"></i>
              </span>
              <span className="font-heading text-lg font-bold text-white">琉璃神社</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-300">
              汇聚海量 ACG 画廊图集，从原画到插画，一站鉴赏多元画风与视觉美学。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white">浏览</h4>
            <ul className="mt-4 space-y-2.5">
              {[
                { href: "#gallery", label: "精选图集" },
                { href: "#styles", label: "画风鉴赏" },
                { href: "#hot", label: "热门推荐" },
              ].map((l) => (
                <li key={l.label}>
                  <a href={l.href} className="text-sm text-background-300 transition hover:text-accent-300 cursor-pointer">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white">关于</h4>
            <ul className="mt-4 space-y-2.5">
              {[
                { href: "#about", label: "关于我们" },
                { href: "#faq", label: "常见问题" },
                { href: "#contact", label: "联系我们" },
              ].map((l) => (
                <li key={l.label}>
                  <a href={l.href} className="text-sm text-background-300 transition hover:text-accent-300 cursor-pointer">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white">关注我们</h4>
            <p className="mt-4 text-sm text-background-300">每天上新精选图集与高清壁纸，与 24w+ 同好一起欣赏视觉之美。</p>
            <div className="mt-4 flex gap-2">
              {["ri-weibo-line", "ri-bilibili-line", "ri-instagram-line"].map((i) => (
                <a
                  key={i}
                  href="#top"
                  className="flex h-9 w-9 items-center justify-center rounded-full bg-background-800 text-background-200 transition hover:bg-primary-500 hover:text-background-50 cursor-pointer"
                  aria-label="社交链接"
                >
                  <i className={`${i} text-lg`}></i>
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-background-800 pt-6 sm:flex-row">
          <p className="text-xs text-background-400">© 2026 琉璃神社官网 · 画廊图集 · 原画插画鉴赏平台</p>
          <a
            href="#top"
            className="inline-flex items-center whitespace-nowrap text-xs text-background-300 transition hover:text-accent-300 cursor-pointer"
          >
            回到顶部
            <i className="ri-arrow-up-line ml-1"></i>
          </a>
        </div>
      </div>
    </footer>
  );
}